const keys = {
  ga: "INSERTKEY",
};

export default keys;
